import { clearModalHack } from '@/services/utils';
import MainHeader from '@/components/MainHeader.vue';
import ProductNotice from '@/components/ProductNotice.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  name: 'Api',
  props: {
    state: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isProcessing: false,
      apiKeys: [],
      me: {}
    };
  },
  components: {
    MainHeader,
    ProductNotice,
    LlSecondaryButton
  },
  async mounted() {
    const [apiKeys, me] = await Promise.all([this.leanLawApi.listApiKeys(), this.userService.getMe()]);
    this.apiKeys = apiKeys.keys;
    this.me = me;
  },
  methods: {
    getLocaleDate(dateString) {
      return new Date(dateString).toLocaleDateString();
    },
    generateApiKey() {
      this.isProcessing = true;
      this.modalService.showModal({
        template: require('../../modals/apiKey/template.html'),
        inputs: {
          apiKey: {}
        },
        bodyClass: 'show-modal-overlay',
        controller: 'ApiKeyModalController'
      }).then(modal => {
        modal.element.modal();
        return modal.close.then(result => {
          clearModalHack();
          if (!result) return;
          const {
            label,
            scope
          } = result;
          this.leanLawApi.generateApiKey({
            body: {
              label,
              scope
            }
          }).then(key => {
            this.alerts.success('Successfully created API key.');
            key.newKey = true;
            this.apiKeys.unshift(key);
          }).catch(err => {
            this.alerts.error(err);
          });
        });
      }, e => {
        console.log('Api Key modal rejected: ', e);
      });
      this.isProcessing = false;
    },
    updateApiKey(key) {
      this.modalService.showModal({
        template: require('../../modals/apiKey/template.html'),
        inputs: {
          apiKey: {
            ...key,
            scope: [...key.scope]
          }
        },
        bodyClass: 'show-modal-overlay',
        controller: 'ApiKeyModalController'
      }).then(modal => {
        modal.element.modal();
        return modal.close.then(result => {
          clearModalHack();
          if (!result) return;
          this.isProcessing = true;
          const {
            label,
            scope
          } = result;
          this.leanLawApi.updateApiKey({
            id: result.id,
            body: {
              label,
              scope
            }
          }).then(k => {
            this.alerts.success('Successfully updated API key.');
            this.apiKeys[this.apiKeys.indexOf(key)] = k;
          }).catch(err => {
            this.alerts.error(err);
          }).finally(() => {
            this.isProcessing = false;
          });
        });
      }, e => {
        console.log('Api Key modal rejected: ', e);
      });
    },
    deleteApiKey(key) {
      bootbox.confirm('Are you sure you want to delete the API Key? Some services might stop functioning.', result => {
        if (!result) return;
        this.leanLawApi.deleteApiKey({
          id: key.id
        }).then(() => {
          this.alerts.success('Successfully deleted API key.');
          const indexToRemove = this.apiKeys.indexOf(key);
          if (indexToRemove > -1) this.apiKeys.splice(indexToRemove, 1);
        }).catch(err => {
          this.alerts.error(err);
        });
      });
    },
    copyToClipboard(apiKey) {
      const textArea = document.createElement('textarea');
      textArea.value = apiKey.key;

      // prevent scrolling to the bottom
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.position = 'fixed';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        this.alerts.success('Key copied to clipboard.');
      } catch (err) {
        this.alerts.error('Failed to copy key: ', err);
      }
      document.body.removeChild(textArea);
    },
    openDocumentation() {
      window.open('https://platform.leanlaw.io', '_blank');
    }
  }
};